export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-Bold.9dae2991.ttf";